import React from "react";
import { Pressable } from "./pressable";
import { stylex } from "./stylex";
import { Text } from "./text";

interface BackButtonProps {
  onPress?: () => void;
  testID?: string;
}

export function BackButton(props: BackButtonProps) {
  const { onPress = () => {} } = props;

  return (
    <Pressable
      onPress={onPress}
      style={({ hovered }) => styles("base", hovered && "hovered")}
    >
      <Text fontSize="lg" color="primary">
        ←
      </Text>
    </Pressable>
  );
}

const styles = stylex.create({
  base: {
    height: 40,
    width: 40,
    display: "flex",
    justifyContent: "center",
    borderRadius: 999,
    alignItems: "center",
  },
  hovered: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
});
